(() => {
  const root = document.documentElement;
  const moneyFormatter = (cents) => {
    const currency = window.EFFECT_THEME?.currency || 'EGP';
    try {
      return new Intl.NumberFormat('ar-EG', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
    }
  };

  const escapeHTML = (value) => {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  };

  /* Mobile menu */
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const openMobile = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
  };
  const closeMobile = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-lock');
  };
  document.querySelector('[data-mobile-menu-toggle]')?.addEventListener('click', openMobile);
  document.querySelector('[data-mobile-menu-close]')?.addEventListener('click', closeMobile);
  mobileMenu?.addEventListener('click', (event) => {
    if (event.target === mobileMenu) closeMobile();
  });

  /* Global cart drawer */
  const cartDrawer = document.querySelector('[data-global-cart-drawer]');
  const cartOverlay = document.querySelector('[data-global-cart-overlay]');
  const cartItems = document.querySelector('[data-global-cart-items]');
  const cartCount = document.querySelector('[data-global-cart-count]');
  const cartTotal = document.querySelector('[data-global-cart-total]');
  const headerCartCount = document.querySelector('[data-header-cart-count]');

  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay?.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
  };

  const closeCart = () => {
    cartDrawer?.classList.remove('is-open');
    cartOverlay?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-lock');
  };

  async function refreshCart() {
    try {
      const response = await fetch(`${window.EFFECT_THEME?.cartUrl || '/cart'}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await response.json();

      if (cartCount) cartCount.textContent = cart.item_count === 1 ? '1 منتج' : `${cart.item_count} منتجات`;
      if (cartTotal) cartTotal.textContent = moneyFormatter(cart.total_price);
      if (headerCartCount) {
        headerCartCount.textContent = cart.item_count;
        headerCartCount.hidden = cart.item_count === 0;
      }

      if (!cartItems) return cart;
      if (!cart.items.length) {
        cartItems.innerHTML = '<div class="effect-cart-empty">سلة التسوق فارغة</div>';
        return cart;
      }

      cartItems.innerHTML = cart.items.map((item, index) => {
        const title = escapeHTML(item.product_title);
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="effect-cart-item__variant">${escapeHTML(item.variant_title)}</div>`
          : '';
        const image = item.image ? `<img src="${item.image}" alt="${title}" loading="lazy">` : '';
        return `
          <article class="effect-cart-item">
            <a href="${item.url}" class="effect-cart-item__image">${image}</a>
            <div class="effect-cart-item__info">
              <a href="${item.url}" class="effect-cart-item__title">${title}</a>
              ${variant}
              <div class="effect-cart-item__price">${moneyFormatter(item.final_line_price)}</div>
              <div class="effect-cart-item__bottom">
                <span class="effect-cart-item__qty">الكمية: ${item.quantity}</span>
                <button type="button" class="effect-cart-item__remove" data-remove-line="${index + 1}">حذف</button>
              </div>
            </div>
          </article>`;
      }).join('');

      cartItems.querySelectorAll('[data-remove-line]').forEach((button) => {
        button.addEventListener('click', async () => {
          button.disabled = true;
          try {
            await fetch(`${window.EFFECT_THEME?.cartChangeUrl || '/cart/change'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: Number(button.dataset.removeLine), quantity: 0 })
            });
            await refreshCart();
          } catch (e) {
            button.disabled = false;
          }
        });
      });
      return cart;
    } catch (e) {
      console.error('EFFECT cart:', e);
      return null;
    }
  }

  document.querySelectorAll('[data-cart-open]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      event.preventDefault();
      await refreshCart();
      openCart();
    });
  });
  document.querySelector('[data-global-cart-close]')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  /* Hero slider */
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-hero-track]');
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (!track || slides.length < 2) return;

    let index = 0;
    const goTo = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(${-index * 100}%)`;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => goTo(index - 1));
    slider.querySelector('[data-hero-next]')?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.heroDot))));

    if (slider.dataset.autoplay === 'true') {
      const speed = Number(slider.dataset.speed) || 5000;
      let timer = setInterval(() => goTo(index + 1), speed);
      slider.addEventListener('mouseenter', () => clearInterval(timer));
      slider.addEventListener('mouseleave', () => { timer = setInterval(() => goTo(index + 1), speed); });
    }
  });

  /* Product carousel */
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    const amount = () => Math.max(track.clientWidth * 0.82, 280);
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  });

  /* Product page */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    if (!form) return;

    const variantsNode = section.querySelector('[data-product-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (e) {}

    const variantIdInput = form.querySelector('[data-selected-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const addButton = form.querySelector('[data-product-add]');
    const buyNow = form.querySelector('[data-product-buy-now]');
    const message = form.querySelector('[data-product-message]');
    const optionGroups = [...section.querySelectorAll('[data-option-position]')].filter((el) => el.matches('fieldset'));

    const currentSelections = () => optionGroups.map((group) => {
      const selected = group.querySelector('[data-option-button].is-selected');
      return selected?.dataset.optionValue || '';
    });

    const getMatchingVariant = () => {
      const selected = currentSelections();
      return variants.find((variant) => variant.options.every((value, i) => value === selected[i]));
    };

    const updateVariantUI = () => {
      const variant = variants.length ? getMatchingVariant() : null;
      if (!variant && variants.length) {
        if (variantIdInput) variantIdInput.value = '';
        if (addButton) { addButton.disabled = true; addButton.textContent = 'الاختيار غير متاح'; }
        if (buyNow) buyNow.disabled = true;
        return null;
      }
      if (!variant) return null;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (price) price.textContent = moneyFormatter(variant.price);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = moneyFormatter(variant.compare_at_price);
          compare.style.display = '';
        } else {
          compare.style.display = 'none';
        }
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'أضف للسلة' : 'نفد المخزون';
      }
      if (buyNow) buyNow.disabled = !variant.available;
       if (mainImage && variant.featured_image) 
        {
        const newSrc = variant.featured_image.src;
        mainImage.style.opacity = '0';
        window.setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.srcset = '';
          mainImage.style.opacity = '1';
        }, 120);
        section.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.image === newSrc);
        });
      }
      return variant;
    };

    section.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('fieldset');
        group?.querySelectorAll('[data-option-button]').forEach((item) => {
          item.classList.toggle('is-selected', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        if (message) message.textContent = '';
        updateVariantUI();
      });
    });

    const qty = form.querySelector('[data-quantity-input]');
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) - 1);
    });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Number(qty.value || 1) + 1;
    });

    const mainImage = section.querySelector('.effect-product__main-image');
    section.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage || !thumb.dataset.image) return;
        mainImage.style.opacity = '0';
        window.setTimeout(() => {
          mainImage.src = thumb.dataset.image;
          mainImage.srcset = '';
          mainImage.style.opacity = '1';
        }, 120);
        section.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    async function addProduct() {
      const variant = variants.length ? updateVariantUI() : null;
      if (variants.length && !variant) {
        if (message) message.textContent = 'من فضلك اختر الخيارات المتاحة أولاً.';
        return false;
      }
      if (!variantIdInput?.value) {
        if (message) message.textContent = 'من فضلك اختر المقاس أولاً.';
        return false;
      }

      const response = await fetch(`${window.EFFECT_THEME?.cartAddUrl || '/cart/add'}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        let errorText = 'تعذر إضافة المنتج للسلة.';
        try {
          const data = await response.json();
          errorText = data.description || errorText;
        } catch (e) {}
        if (message) message.textContent = errorText;
        return false;
      }
      if (message) message.textContent = '';
      return true;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton) return;
      const old = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'جاري الإضافة...';
      try {
        const ok = await addProduct();
        if (!ok) {
          updateVariantUI();
          return;
        }
        addButton.textContent = '✓ تمت الإضافة';
        await refreshCart();
        openCart();
        setTimeout(() => updateVariantUI(), 1000);
      } catch (e) {
        if (message) message.textContent = 'حدث خطأ أثناء الإضافة. حاول مرة أخرى.';
        addButton.disabled = false;
        addButton.textContent = old;
      }
    });

    buyNow?.addEventListener('click', async () => {
      const old = buyNow.textContent;
      buyNow.disabled = true;
      buyNow.textContent = 'جاري التحويل...';
      try {
        const ok = await addProduct();
        if (!ok) {
          updateVariantUI();
          buyNow.textContent = old;
          return;
        }
        window.location.href = window.EFFECT_THEME?.checkoutUrl || '/checkout';
      } catch (e) {
        buyNow.disabled = false;
        buyNow.textContent = old;
      }
    });

    updateVariantUI();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCart();
      closeMobile();
    }
  });
})();
